import { render } from "./Topics.vue?vue&type=template&id=c194b51a&scoped=true&lang=pug"
import script from "./Topics.vue?vue&type=script&lang=js"
export * from "./Topics.vue?vue&type=script&lang=js"

import "./Topics.vue?vue&type=style&index=0&id=c194b51a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c194b51a"]])

export default __exports__